(function ($) {
	$.fn.isInViewport = function() {
		const elementTop = $(this).offset().top;
		const elementBottom = elementTop + $(this).outerHeight();

		const viewportTop = $(window).scrollTop();
		const viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	};

	class Helpers {
		throttle(func, delay) {
			let lastCallTime = 0;

			return function (...args) {
				const currentTime = new Date().getTime();

				if (currentTime - lastCallTime >= delay) {
					func.apply(this, args);
					lastCallTime = currentTime;
				}
			};
		}

		debounce(func, delay) {
			let timeoutId;

			return function (...args) {
				clearTimeout(timeoutId);

				timeoutId = setTimeout(() => {
					func.apply(this, args);
				}, delay);
			};
		}
	}

	window.Helpers = new Helpers();

	class Website {
		constructor() {
			this.installListeners();
		}

		installListeners() {
			$(document).on('click', '[href="#contact-form"]', function(e){
				e.preventDefault();

				const $contactForm = $('.contact-form-section');
				const offset = 40;

				if ($contactForm.length) {
					$('html, body').animate({
						scrollTop: $contactForm.offset().top - offset
					}, 500);
				}
			});
		}
	}

	window.Website = new Website();


	class RiveAnimations {
		constructor(canvas) {
			this.canvas = canvas;
			this.file = this.canvas.getAttribute('data-src');
			this.instance = null;
			this.buffer = null;

			this.installListeners();
			this.installObserver();
		}

		initRive() {
			const config = {
				canvas: this.canvas,
				autoplay: true,
				stateMachines: "State Machine 1",
				shouldDisableRiveListeners: true,
				onLoad: () => {
					this.instance.resizeDrawingSurfaceToCanvas();
					this.buffer = this.instance.buffer;
				}
			};

			if (this.buffer) {
				config.buffer = this.buffer;
			} else {
				config.src = this.file;
			}

			this.instance = new rive.Rive(config);

			this.instance.layout = new rive.Layout({
				fit: rive.Fit.Contain,
				alignment: rive.Alignment.Center,
			});
		}

		installListeners() {
			window.addEventListener("resize", () => {
				this.instance.resizeDrawingSurfaceToCanvas();
			});
		}

		installObserver() {
			const observer = new IntersectionObserver(entries => {
				for (const entry of entries) {
					if (entry.isIntersecting) {
						this.initRive();
					}
				}
			},{
				root: null,
				rootMargin: '0px'
			});

			observer.observe(this.canvas);
		}
	}

	function initRiveAnimations() {
		const riveAnimations = document.querySelectorAll('.rive-animation');

		if (riveAnimations.length) {
			riveAnimations.forEach((el) => {
				new RiveAnimations(el);
			});
		}
	}

	if (window.rive === undefined) {
		const script = document.createElement('script');

		script.src = globalSettings.theme_url + '/assets/dist/js/rive.js?v=2.7.0';
		script.async = true;
		script.onload = () => {
			initRiveAnimations();
		};

		document.head.appendChild(script);
	} else {
		initRiveAnimations();
	}


	$('.video-container .play').on('click', function(e){
		e.preventDefault();

		const $button = $(this);
		const video = $button.closest('.video-container').find('video')[0];

		$button.addClass('is-hidden');

		video.play();
		video.setAttribute('controls', 'controls');

		const onEnded = video.addEventListener('ended', function(){
			video.removeAttribute('controls');

			setTimeout(() => {
				video.currentTime = 0;
				$button.removeClass('is-hidden');
				video.removeEventListener('ended', onEnded);
			}, 500);
		});
	});

	if (typeof AOS === 'object') {
		AOS.init({
			duration: 500,
			delay: 50
		});

		window.addEventListener("load", AOS.refresh);
	}

})(jQuery);
